module.exports = __webpack_public_path__ + "media/audio18.92318a82.mp3";